<div class="p-3 menu-navigation">
  <mat-form-field ngClass="input-normalize mat-field-fluid">
    <input type="search" matInput [formControl]="formFilter" placeholder="Search" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <div [formGroup]="form">
    @if (isLoading()) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-selection-list [hideSingleSelectionIndicator]="true" formControlName="organization" [multiple]="false">
      <mat-list-option class="menu-item" [value]="null">
        <div class="menu-item">
          <mat-icon>database</mat-icon>
          <div class="menu-item-text">Issues Dashboard</div>
        </div>
      </mat-list-option>
      @for (organization of organizationList()?.filtered; track organization) {
        <mat-list-option class="menu-item" [value]="organization.pk">
          <span class="menu-item-content">
            {{ organization.name }}
          </span>
        </mat-list-option>

        @if (selectedOrganization() === organization.pk) {
          <mat-list-option class="ps-4" [routerLink]="['/organizations', selectedOrganization(), 'home']">
            <div class="menu-item-content d-flex align-items-center g-2">
              <mat-icon>subdirectory_arrow_right</mat-icon>
              <div>View details</div>
            </div>
          </mat-list-option>
        }
      } @empty {
        <mat-list-option disabled role="listitem">No organizations found</mat-list-option>
      }
    </mat-selection-list>
  </div>
</div>
